type TableButtonProps = {
  children: React.ReactNode;
  className?: string;
  onClick: () => void;
  disabled?: boolean;
};

export default function TableButton({
  children,
  className,
  onClick,
  disabled = false,
}: TableButtonProps) {
  return (
    <button
      className={`py-1 px-2 border rounded hover:bg-gray-100 ${
        className ? className : ''
      } ${
        disabled
          ? 'bg-gray-100 border-gray-300 text-gray-300 select-none cursor-default'
          : ''
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
